/**
 * Citations API client
 */

import { apiClient } from './client'

export interface CitationPaper {
  title: string
  authors: string[]
  year?: number
  doi?: string
  pmid?: string
  arxiv_id?: string
  abstract?: string
  venue?: string
  url?: string
  relevance_score?: number
  relevance_explanation?: string
  bibtexKey?: string // Generated citation key for LaTeX/BibTeX
}

export type CitationMode = 'statement' | 'research'

export interface CitationSuggestionRequest {
  text: string
  context?: string
  max_results?: number
  field?: string
  profile_id?: string
  citation_mode?: CitationMode
}

export interface CitationSuggestionResponse {
  suggestions: CitationPaper[]
  query_count: number
  papers_retrieved: number
  success: boolean
}

class CitationsAPI {
  /**
   * Suggest citations for the given text
   */
  async suggestCitations(
    request: CitationSuggestionRequest
  ): Promise<CitationSuggestionResponse> {
    return await apiClient.post('/api/citations/suggest', request)
  }
}

export const citationsAPI = new CitationsAPI()
export default citationsAPI

